<!-- @format -->

<ng-container *transloco="let t">
  @if (courseUnitRealisation) {
    @if (courseUnitRealisation.tweetText) {
      <p class="key-text">
        {{ courseUnitRealisation.tweetText | localizedString }}
      </p>
    }
    <div class="mb-5 mb-sm-3">
      <sis-tab-content-switch [(currentIndex)]="currentTabIndex" type="pills" [tabs]="tabs"></sis-tab-content-switch>
    </div>
    <app-course-unit-realisation-basic-info
      [hidden]="currentTabIndex !== 0"
      [courseUnitRealisation]="courseUnitRealisation"
      [courseUnitId]="courseUnit.id"></app-course-unit-realisation-basic-info>
    <fudis-grid [hidden]="currentTabIndex !== 1" [rowGap]="'sm'">
      <fudis-grid-item>
        <fudis-dl>
          <fudis-dl-item>
            <fudis-dd>
              <fudis-dl [variant]="'compact'">
                @if (courseUnitRealisation.enrolmentPeriod) {
                  <fudis-dl-item>
                    <fudis-dt [contentText]="t('SIS_COMPONENTS.COURSE_UNIT_REALISATION_INFO.ENROLMENT_TIME')"></fudis-dt>
                    <fudis-dd [contentText]="courseUnitRealisation.enrolmentPeriod | localDateTimeRange"></fudis-dd>
                  </fudis-dl-item>
                }
                @if (courseUnitRealisation.enrolmentAdditionalCancellationEnd) {
                  <fudis-dl-item>
                    <fudis-dt
                      [contentText]="t('SIS_COMPONENTS.COURSE_UNIT_REALISATION_INFO.ENROLMENT_ADDITIONAL_CANCELLATION_END')"></fudis-dt>
                    <fudis-dd [contentText]="courseUnitRealisation.enrolmentAdditionalCancellationEnd | localDateTimeFormat"></fudis-dd>
                    <fudis-icon-button
                      [popoverText]="t('SIS_COMPONENTS.COURSE_UNIT_REALISATION_INFO.ENROLMENT_ADDITIONAL_CANCELLATION_END_GUIDANCE')"
                      [variant]="'tertiary'"
                      [icon]="'info-circle'"
                      [ariaLabel]="t('ARIA_LABEL.SHOW_DETAILS')"
                      [size]="'extra-small'" />
                  </fudis-dl-item>
                }
                @if (courseUnitRealisation.lateEnrolmentEnd) {
                  <fudis-dl-item>
                    <fudis-dt [contentText]="t('SIS_COMPONENTS.COURSE_UNIT_REALISATION_INFO.LATE_ENROLMENT_END')"></fudis-dt>
                    <fudis-dd [contentText]="courseUnitRealisation.lateEnrolmentEnd | localDateTimeFormat"></fudis-dd>
                    <fudis-icon-button
                      [ariaLabel]="t('ARIA_LABEL.SHOW_DETAILS')"
                      [popoverText]="t('SIS_COMPONENTS.COURSE_UNIT_REALISATION_INFO.LATE_ENROLMENT_END_GUIDANCE')"
                      [icon]="'info-circle'"
                      [variant]="'tertiary'"
                      [size]="'extra-small'" />
                  </fudis-dl-item>
                }
              </fudis-dl>
            </fudis-dd>
          </fudis-dl-item>
        </fudis-dl>
      </fudis-grid-item>
      @if (enrolmentCalculationConfig$ | async; as enrolmentCalculationConfig) {
        <fudis-grid-item>
          <sis-course-unit-realisation-seats
            [level]="level + 1"
            [enrolmentCalculationConfig]="enrolmentCalculationConfig"></sis-course-unit-realisation-seats>
        </fudis-grid-item>
        @if (enrolmentCalculationConfig.requirementPersonRules !== null && enrolmentCalculationConfig.requirementPersonRules.length > 0) {
          <fudis-grid-item>
            <div class="form-group-mimic">
              <div role="heading" [attr.aria-level]="level + 1" class="sis-label">{{
                t("SIS_COMPONENTS.COURSE_UNIT_REALISATION_INFO.REQUIREMENT_PERSON_RULES")
              }}</div>
              <p class="sis-guidance">{{ t("SIS_COMPONENTS.COURSE_UNIT_REALISATION_INFO.REQUIREMENT_PERSON_RULES_HELP") }}</p>
              <ul class="person-rules">
                @for (rule of enrolmentCalculationConfig.requirementPersonRules; track $index) {
                  <li>{{ rule | personRequirementRuleName | async }}</li>
                }
              </ul>
            </div>
          </fudis-grid-item>
        }
        @if (enrolmentCalculationConfig.orderingPersonRules !== null && enrolmentCalculationConfig.orderingPersonRules.length > 0) {
          <fudis-grid-item>
            <div class="form-group-mimic">
              <div role="heading" [attr.aria-level]="level + 1" class="sis-label" translate
                >SIS_COMPONENTS.COURSE_UNIT_REALISATION_INFO.ORDERING_PERSON_RULES</div
              >
              <p class="sis-guidance" translate="SIS_COMPONENTS.COURSE_UNIT_REALISATION_INFO.ORDERING_PERSON_RULES_HELP"></p>
              <ul class="person-rules ordering-person-rules">
                @for (rule of enrolmentCalculationConfig.orderingPersonRules; track $index) {
                  <li>{{ rule | personRequirementRuleName: true | async }}</li>
                }
              </ul>
            </div>
          </fudis-grid-item>
        }
      }
    </fudis-grid>
    <div [hidden]="currentTabIndex !== 2">
      @if (courseUnitRealisation.studyGroupSets?.length > 0) {
        <app-student-course-unit-realisation-structure
          class="study-sub-group-structure"
          [subGroupLevel]="level + 1"
          [courseUnitRealisation]="courseUnitRealisation">
        </app-student-course-unit-realisation-structure>
      }
    </div>
  }
</ng-container>
